import React, { Component } from "react";
import { Container, Button } from "react-bootstrap";
import { connect } from "react-redux";
import FindProvider from "./Search/FindProvider/FindProvider";
import MyFavorites from "./Search/MyFavorites/MyFavorites";
import { withTranslation } from "react-i18next";

import classes from "./FindProvider.module.css";
interface IStateFromProps {
  appConfig: {
    modules: string[];
    theme: string;
  };
  t: any;
}

type Props = IStateFromProps;
class FindProviderContainer extends Component<Props> {
  state = {
    findProvider: true,
    myFavorites: false,
    modules:
      localStorage.getItem("modulesConfig") &&
      localStorage.getItem("modulesConfig") !== ""
        ? localStorage.getItem("modulesConfig")?.split(",")
        : [],
  };

  findProviderHandler = () => {
    this.setState({ findProvider: true });
    this.setState({ myFavorites: false });
  };

  myFavoritesHandler = () => {
    this.setState({ findProvider: false });
    this.setState({ myFavorites: true });
  };

  componentDidMount() {
    document.body.classList.toggle("bgLight", true);
  }
  componentWillReceiveProps(nextProps) {
    document.body.classList.toggle("bgLight", true);
  }
  componentWillUnmount() {
    document.body.classList.remove("bgLight");
  }

  render() {
    let findProvider: any;
    let myFavorites: any;
    if (this.state.findProvider) {
      findProvider = <FindProvider />;
    }
    if (this.state.myFavorites) {
      myFavorites = <MyFavorites mapDisplay={true} />;
    }
    let { t } = this.props;
    return (
      <Container fluid>
        <Button
          className={[
            "btnTabs",
            `${this.state.findProvider && classes.tabsActive} expanded`,
          ].join(" ")}
          onClick={this.findProviderHandler}
        >
          {t("findProviderPage.findProvider")}
        </Button>
        {this.state.modules &&
          this.state.modules.findIndex(
            (module) => module === "My Favorites"
          ) !== -1 && (
            <Button
              className={[
                "btnTabs",
                `${this.state.myFavorites && classes.tabsActive}`,
              ].join(" ")}
              onClick={this.myFavoritesHandler}
            >
              {t("menuBar.myFavorite")}
            </Button>
          )}
        {findProvider}
        {myFavorites}
      </Container>
    );
  }
}
const mapStateToProps = (state: any) => ({
  appConfig: state.appConfig.appConfig,
});

export default connect(mapStateToProps)(
  withTranslation()(FindProviderContainer)
);
